import React from "react";
import WbSunnyOutlinedIcon from "@mui/icons-material/WbSunnyOutlined";
import Battery0BarIcon from "@mui/icons-material/Battery0Bar";

import { SegmentedOptionT } from "components/mui-styled-components/SmartFormElements/SmartFormSegmentedControl";

// Battery-Only program: what the homeowner is shopping for, captured at lead
// creation. Values mirror the backend leads.homeowner_interest enum.
export const homeownerInterestOptions: SegmentedOptionT[] = [
  { value: "solar", label: "Solar", icon: <WbSunnyOutlinedIcon sx={{ fontSize: "16px" }} /> },
  {
    value: "battery_only",
    label: "Battery",
    icon: <Battery0BarIcon sx={{ fontSize: "18px", transform: "rotate(90deg)" }} />,
  },
  { value: "both", label: "Both" },
];

export const proposalProductOptions: SegmentedOptionT[] = [
  { value: "solar", label: "Solar", icon: <WbSunnyOutlinedIcon sx={{ fontSize: "16px" }} /> },
  {
    value: "battery",
    label: "Battery",
    icon: <Battery0BarIcon sx={{ fontSize: "18px", transform: "rotate(90deg)" }} />,
  },
];
